function createNotification(message) {
  return new Notification(message);
}

function showQueueNotification(messageWS, queueName, locationName) {
  var message = '';
  var customerType = messageWS.get('customer');

  if (locationName) {
    message = messageWS.get('notification.message.multipleLocations')
        .replace('{0}', customerType)
        .replace('{1}', queueName)
        .replace('{2}', locationName);
  } else {
    message = messageWS.get('notification.message')
      .replace('{0}', customerType)
      .replace('{1}', queueName);
  }

  createNotification(message);
}

module.exports = {
  showQueueNotification: showQueueNotification,
  createNotification:  createNotification,
}
